module.exports = __webpack_public_path__ + "static/media/content-03-m.e3f1ba42.png";